import { useState } from "react";
import { Pagination } from "../../components";
import PaymentItem from "./PaymentItem";
import Filter from './Filter';

function Table({ transactions, setTransactions, setLoading }) {

    const [currentPage, setCurrentPage] = useState(1);
    const [recordsPerPage] = useState(10);
    const indexOfLastRecord = currentPage * recordsPerPage;
    const indexOfFirstRecord = indexOfLastRecord - recordsPerPage;
    const currentRecords = transactions?.slice(indexOfFirstRecord, indexOfLastRecord);
    const nPages = Math.ceil(transactions?.length / recordsPerPage);

    return (
        <div className="space-y-4 pt-4">
            <div className="flex items-center justify-end">
                <Filter
                    setLoading={setLoading}
                    setTransactions={setTransactions}
                />
            </div>

            <div className="bg-white dark:bg-gray-800 rounded-xl border border-gray-100 dark:border-gray-700 shadow-sm overflow-hidden">
                <div className="overflow-x-auto">
                    <table className="min-w-full table-fixed">
                        <thead>
                            <tr className="bg-gray-50/60 dark:bg-gray-900/60">
                                <th className="px-5 py-2.5 text-left text-xs font-semibold text-gray-400 dark:text-gray-500 uppercase tracking-wide w-32">Date</th>
                                <th className="px-5 py-2.5 text-left text-xs font-semibold text-gray-400 dark:text-gray-500 uppercase tracking-wide">Message</th>
                                <th className="px-5 py-2.5 text-left text-xs font-semibold text-gray-400 dark:text-gray-500 uppercase tracking-wide w-32">Status</th>
                                <th className="px-5 py-2.5 text-left text-xs font-semibold text-gray-400 dark:text-gray-500 uppercase tracking-wide w-16">Action</th>
                            </tr>
                        </thead>

                        <tbody className="divide-y divide-gray-50 dark:divide-gray-700/50">
                            {currentRecords && currentRecords.length > 0 ? (
                                currentRecords.map(item => (
                                    <PaymentItem key={item?._id} item={item} />
                                ))
                            ) : (
                                <tr>
                                    <td colSpan="4" className="px-5 py-10 text-center text-sm text-gray-400">
                                        No transactions found
                                    </td>
                                </tr>
                            )}
                        </tbody>
                    </table>
                </div>

                {currentRecords && currentRecords.length > 0 && (
                    <Pagination
                        nPages={nPages}
                        currentPage={currentPage}
                        setCurrentPage={setCurrentPage}
                        length={transactions?.length}
                    />
                )}
            </div>
        </div>
    );
}

export default Table;
